import axios from '../../axios';
import * as types from '../actionTypes';

const addVoteRequest = () => ({type: types.ADD_VOTE_REQUEST});
const addVoteSuccess = () => ({type: types.ADD_VOTE_SUCCESS});
const addVoteFailure = error => ({type: types.ADD_VOTE_FAILURE, error});

export const addVote = data => {
  return dispatch => {
    dispatch(addVoteRequest());
    return axios.post('/api/private/add_vote', data).then(
      () => {
        dispatch(addVoteSuccess());
      },
      error => {
        dispatch(addVoteFailure(error));
      }
    )
  }
};

const checkVotedRequest = () => ({type: types.CHECK_VOTED_REQUEST});
const checkVotedSuccess = voted => ({type: types.CHECK_VOTED_SUCCESS, voted});
const checkVotedFailure = error => ({type: types.CHECK_VOTED_FAILURE, error});

export const checkVoted = data => {
  return dispatch => {
    dispatch(checkVotedRequest());
    return axios.post('/api/private/ckeck_vote', data).then(
      response => {
        dispatch(checkVotedSuccess(response.data));
      },
      error => {
        dispatch(checkVotedFailure(error));
      }
    )
  }
};

const fetchPracticeVotesRequest = () => ({type: types.FETCH_PRACTICE_VOTES_REQUEST});
const fetchPracticeVotesSuccess = practiceVotes => ({type: types.FETCH_PRACTICE_VOTES_SUCCESS, practiceVotes});
const fetchPracticeVotesFailure = error => ({type: types.FETCH_PRACTICE_VOTES_FAILURE, error});

export const fetchPracticeVotes = query => {
  return dispatch => {
    dispatch(fetchPracticeVotesRequest());
    return axios.get(`/api/list/practice-votes${query || ''}`).then(
      response => {
        dispatch(fetchPracticeVotesSuccess(response && response.data));
      },
      error => {
        dispatch(fetchPracticeVotesFailure(error));
      }
    )
  }
};